<template>
    <div class="header-container" :class="{ 'header-container--centered': theme === 'dynamicStyle' }">
        <img
            class="logo"
            :src="image ? image : '/images/liberrex_full.png'"
            alt="Logo"
        />
    </div>
</template>
<script>
import colorShader from "@/_helpers/color-shader";
import router from "@/router";
export default {
    name: 'LbrxDisplayHeader',
    props: {
        image: {
            required: false,
            value: String
        },
        theme: {
            required: false,
            value: String
        }
    },
    computed: {
        makeColorDarker() {
            return colorShader.methods.newShade(this.primaryColor, -50);
        },
    }
}
</script>

<style scoped>
.header-container {
    flex-shrink: 0;
    padding: 0.5vmin 1vmin;
    background: #FFFFFF !important;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 0;
    height: 7.8vh;
    box-sizing: border-box;
    overflow: hidden;
}

.header-container--centered {
    justify-content: center;
}

.header-container:not(.header-container--centered) {
    justify-content: flex-start;
}

.logo {
    display: block;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
}


/* @media (max-width: 900px) {
    .header-container {
        padding: 2vmin;
    }
} */

</style>